module.exports = __webpack_public_path__ + "img/FullPlant.5bdb1add.png";